import React from "react";
import Helmet from "react-helmet";

import Title from "../components/Title";
import Item from "../components/Item";
import Content from "../components/Content";

export default () => (
  <>
    <Helmet>
      <Item>Terms of Service | Heungdo Lab</Item>
    </Helmet>
    <div>
      <Title>Terms of Service</Title>

      <Item>Your Commitments</Item>
      <br />
      <Content>
        In return for our commitment to provide the Service, we require you to
        make the below commitments to us.
      </Content>
      <Content>
        - You can't do anything unlawful, misleading, or fraudulent or for an
        illegal or unauthorized purpose.
      </Content>
      <Content>
        - You can't do anything to interfere with or impair the intended
        operation of the Service. This includes misusing any reporting, dispute,
        or appeals channel, such as by making fraudulent or groundless reports
        or appeals.
      </Content>
      <Content>
        - You can't post someone else’s private or confidential information
        without permission or do anything that violates someone else's rights,
        including intellectual property rights (e.g., copyright infringement,
        trademark infringement, counterfeit, or pirated goods).${`\n\n`}- You
        can’t modify, translate, create derivative works of, or reverse engineer
        our products or their components.
      </Content>
      <Content>- You can't post objectionable or abusive content.</Content>
      <br />
      <Item>Content Removal and Disabling or Terminating Your Account</Item>
      <br />
      <Content>
        - We can remove any content or information you share on the Service if
        we believe that it violates these Terms of Use, our policies or we are
        required to do so by law. We can refuse to provide or stop providing all
        or part of the Service to you immediately to protect our community or
        services, or if you create risk or legal exposure for us, violate these
        Terms of Use or our policies, if you repeatedly infringe other people's
        intellectual property rights, or where we are permitted or required to
        do so by law. We can also terminate or change the Service, remove or
        block content or information shared on our Service, or stop providing
        all or part of the Service if we determine that doing so is reasonably
        necessary to avoid or mitigate adverse legal or regulatory impacts on
        us.
      </Content>
    </div>
  </>
);
